import { useEffect, useState } from 'react'
import { LoadingSpinner } from '~/components'
import BazaarVoiceScript from '~/components/BazaarVoiceScript/BazaarVoiceScript'
import { ProductReviewsProps } from '~/sections/ProductDetails/ProductDetails.types'

if (typeof window !== 'undefined') {
  window.bvCallback = function (BV) {
    BV.configure('global', {
      events: {
        bvRender() {
          window.dispatchEvent(new Event('resize'))
        },
      },
    })
  }
}

export const ProductReviews = ({ bazaarVoice }: ProductReviewsProps) => {
  const [hasScrolled, setHasScrolled] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(true)
    }

    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)

    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  return (
    <>
      {hasScrolled && <BazaarVoiceScript {...bazaarVoice} />}
      <div
        data-bv-show='reviews'
        data-bv-product-id={bazaarVoice.productIdentifier}>
        <div className='flex item-center py-4'>
          <LoadingSpinner />
        </div>
      </div>
    </>
  )
}
